var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPermissions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Outline/shield-check"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.48241 1.4669C9.77989 1.16435 10.23 1.16435 10.5275 1.46691C12.0528 3.01828 14.0651 3.96055 16.273 3.96055C16.4221 3.96055 16.5703 3.95625 16.7174 3.94777C17.0889 3.92636 17.4224 4.20469 17.5156 4.61387C17.7275 5.54403 17.84 6.51871 17.84 7.52195C17.84 12.9164 14.5932 17.4468 10.2003 18.7317C10.0722 18.7691 9.9378 18.7691 9.80969 18.7317C5.41678 17.4468 2.16998 12.9164 2.16998 7.52195C2.16998 6.51867 2.2825 5.54395 2.49438 4.61376C2.58758 4.20458 2.9211 3.92625 3.29257 3.94766C3.4397 3.95614 3.58786 3.96044 3.73698 3.96044C5.94482 3.96044 7.95712 3.01821 9.48241 1.4669ZM3.87915 5.74002C3.78583 6.31731 3.73698 6.91281 3.73698 7.52195C3.73698 12.004 6.38712 15.7847 10.005 16.9473C13.6228 15.7847 16.273 12.004 16.273 7.52195C16.273 6.91285 16.2241 6.31739 16.1308 5.74012C13.8224 5.70421 11.6983 4.79481 10.0049 3.29061C8.31154 4.79474 6.18748 5.70409 3.87915 5.74002Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon (Stroke)",
    d: "M9.31112 6.88884C9.31112 6.50838 9.61955 6.19995 10 6.19995C10.3805 6.19995 10.6889 6.50838 10.6889 6.88884V9.31106H13.1111C13.4916 9.31106 13.8 9.61949 13.8 9.99995C13.8 10.3804 13.4916 10.6888 13.1111 10.6888H10.6889V13.1111C10.6889 13.4915 10.3805 13.8 10 13.8C9.61955 13.8 9.31112 13.4915 9.31112 13.1111V10.6888H6.8889C6.50844 10.6888 6.20001 10.3804 6.20001 9.99995C6.20001 9.61949 6.50844 9.31106 6.8889 9.31106H9.31112V6.88884Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPermissions);
export default __webpack_public_path__ + "static/media/permissions.cb45d09d2a8962ad6981019300831273.svg";
export { ForwardRef as ReactComponent };